function getFocusableElements(container) {
  if (!container) return [];

  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class MultiTab extends HTMLElement {
  constructor() {
    super();
    this.mainTabs = this.querySelectorAll(".tabs-with-info-items__main-tab");
    this.selectTabs = this.querySelector(".tabs-with-info-items__select");
    this.subTabs = this.querySelectorAll(".tabs-with-info-items__sub-tab");
    this.subTabContainers = this.querySelectorAll(
      ".tabs-with-info-items__sub-tab-container"
    );

    this.hideSubTabs(1);
    this.injectContent();

    this.selectTabs?.addEventListener("change", () => {
      this.hideSubTabs(this.selectTabs.value);

      this.mainTabs.forEach((tab) => {
        tab.removeAttribute("active");
      });

      this.querySelector(".tabs-with-info-items__info-area").innerHTML = "";

      this.subTabs.forEach((subTab) => {
        subTab.removeAttribute("active");
        if (subTab.dataset.tab == this.selectTabs.value) {
          subTab.setAttribute("active", "");
        }
      });

      this.injectContent();
    });

    this.mainTabs.forEach((tab, i) => {
      tab.addEventListener("click", () => {
        this.hideSubTabs(i + 1);

        this.mainTabs.forEach((tab) => {
          tab.removeAttribute("active");
        });

        this.querySelector(".tabs-with-info-items__info-area").innerHTML = "";

        tab.setAttribute("active", "");

        this.subTabs.forEach((subTab) => {
          subTab.removeAttribute("active");
          if (subTab.dataset.tab == i + 1 && subTab.dataset.subTab == 1) {
            subTab.setAttribute("active", "");
          }
        });

        this.injectContent();
      });
    });

    this.subTabs.forEach((subTab) => {
      subTab.addEventListener("click", () => {
        this.subTabs.forEach((subTab) => {
          subTab.removeAttribute("active");
        });
        subTab.setAttribute("active", "");
        this.injectContent();
      });
    });
  }

  hideSubTabs(i) {
    this.subTabContainers.forEach((subTabContainer) => {
      if (!(subTabContainer.dataset.tab == i)) {
        subTabContainer.classList.add("hidden");
      } else {
        subTabContainer.classList.remove("hidden");
      }
    });
  }

  injectContent() {
    this.subTabs.forEach((subTab) => {
      if (subTab.hasAttribute("active")) {
        const content = subTab.querySelector(
          ".tabs-with-info-items__sub-tab-content"
        ).innerHTML;
        this.querySelector(".tabs-with-info-items__info-area").innerHTML =
          content;
      }
    });
  }
}

customElements.define("multi-tab", MultiTab);

class SwiperComponent extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const disabledMobile = this.hasAttribute("disabled-mobile");
    const disabledDesktop = this.hasAttribute("disabled-desktop");
    const pagination = this.querySelector(".swiper-pagination");
    const next = this.parentElement.querySelector(".slider-button--next");
    const prev = this.parentElement.querySelector(".slider-button--prev");

    const swiper = new Swiper(this, {
      direction: "horizontal",
      grabCursor: false,
      slidesPerView: parseFloat(this.dataset.slidesMobile) || 1,
      spaceBetween: parseFloat(this.dataset.gapMobile) || 15,
      slideOffsetBefore: 150,
      loop: true,
      enabled: !disabledMobile || true,
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      pagination: {
        el: pagination,
        type: this.dataset.paginationType,
        clickable: true,
      },
      a11y: false,
      breakpoints: {
        750: {
          slidesPerView: parseFloat(this.dataset.slidesDesktop) || 4,
          spaceBetween: parseFloat(this.dataset.gapDesktop) || 15,
          enabled: !disabledDesktop || true,
        },
      },
    });

    if (disabledMobile && disabledDesktop) {
      swiper.disable();
    } else if (!disabledMobile && disabledDesktop) {
      if (window.innerWidth >= 750) {
        swiper.disable();
      }
    } else if (disabledMobile && !disabledDesktop) {
      if (window.innerWidth < 750) {
        swiper.disable();
      }
    }

    window.addEventListener("resize", () => {
      if (disabledMobile && disabledDesktop) {
        swiper.disable();
      } else if (!disabledMobile && disabledDesktop) {
        if (window.innerWidth >= 750) {
          swiper.disable();
        } else {
          swiper.enable();
        }
      } else if (disabledMobile && !disabledDesktop) {
        if (window.innerWidth < 750) {
          swiper.disable();
        } else {
          swiper.enable();
        }
      }
    });
  }
}

customElements.define("swiper-component", SwiperComponent);

class SliderComponent extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.sliderDots = this.querySelector(".slider-dots");
    this.currentActiveDot = this.querySelector(".slider-dots .dot.active");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton?.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton?.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.sliderDots) {
      this.currentActiveDot.classList.remove("active");
      this.currentActiveDot = this.sliderDots.querySelector(
        `.dot:nth-child(${this.currentPage})`
      );
      this.currentActiveDot.classList.add("active");
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;
    if (!this.nextButton) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    if (!this.slider) return false;

    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.loadRecommendations();
    };

    const observer = new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    });
    observer.observe(this);

    // If element is already visible (e.g., in cart drawer that's already open), trigger load immediately
    // Check after a brief delay to ensure layout is complete
    setTimeout(() => {
      const rect = this.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight + 400 && rect.bottom > -400;
      if (isVisible && !this.classList.contains('product-recommendations--loaded')) {
        observer.unobserve(this);
        this.loadRecommendations();
      }
    }, 100);
  }

  loadRecommendations() {
    if (!this.dataset.url) return;
    
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          
          // If this is in the cart drawer, initialize form handlers
          if (this.classList.contains('cart-drawer--recommendations-mobile')) {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.initRecommendationForms === 'function') {
              // Small delay to ensure DOM is ready
              setTimeout(() => {
                cartDrawer.initRecommendationForms();
              }, 50);
            }
          }
        }

        if (
          !this.querySelector("slideshow-component") &&
          this.classList.contains("complementary-products")
        ) {
          this.remove();
        }

        if (html.querySelector(".grid__item")) {
          this.classList.add("product-recommendations--loaded");
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class ModalPopup extends HTMLElement {
  constructor() {
    super();

    this.eventName = this.getAttribute("data-event-name");
    this.modalPopup = document.getElementById("modal-popup-" + this.eventName);
  }

  connectedCallback() {
    const self = this;
    document.addEventListener(this.eventName, function () {
      self.modalPopup.classList.remove("hidden");
    });
  }
}

customElements.define("modal-popup", ModalPopup);

document.addEventListener("DOMContentLoaded", function () {
  const eventButtons = document.querySelectorAll("a[click-event]");
  const modalCloseButton = document.querySelectorAll(
    ".modal-popup__close-button"
  );
  const modalPopup = document.querySelectorAll(".modal-popup");

  eventButtons.forEach(function (button) {
    const eventName = button.dataset.eventName;

    if (!eventName) {
      return;
    }

    button.addEventListener("click", function () {
      document.dispatchEvent(
        new CustomEvent(eventName, {
          detail: {},
        })
      );
    });
  });

  modalCloseButton.forEach(function (button) {
    button.addEventListener("click", function () {
      button.closest(".modal-popup").classList.add("hidden");
    });
  });

  modalPopup.forEach(function (popup) {
    popup.addEventListener("click", function (event) {
      if (event.target === popup) {
        popup.classList.add("hidden");
      }
    });
  });
});

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector("video");
    this.unmuteButton = this.querySelector(".icon-unmute");
    this.muteButton = this.querySelector(".icon-mute");

    if (!this.video) {
      return;
    }

    this.unmuteButton.addEventListener("click", this.unmute.bind(this));
    this.muteButton.addEventListener("click", this.mute.bind(this));
  }

  connectedCallback() {
    if (!this.video) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.video.currentTime = 0;
            this.video.play();
          }
          else {
            this.video.pause();
          }
        });
      },
      {
        threshold: 0.5,
      }
    );

    observer.observe(this);
  }

  unmute() {
    this.video.muted = true;
    this.unmuteButton.style.display = "none";
    this.muteButton.style.display = "block";
  }

  mute() {
    this.video.muted = false;
    this.unmuteButton.style.display = "block";
    this.muteButton.style.display = "none";
  }
}

customElements.define("video-component", VideoComponent);

class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.arrangeContent();
    const swatchContainer = this.querySelector('.product-links-swatches');

    if (swatchContainer) {
      this.originalProductImage = swatchContainer.dataset.originalProductImage;
    }
    
    this.productLinkSwatches = this.querySelector('.product-links-swatches');
    this.swatches = this.querySelectorAll('.product-links-swatches > product-swatch > a');
    this.originalSwatch = this.querySelector('.product-links-swatches > product-swatch > a.active')
    this.activeSwatch = this.originalSwatch;

    this.variantsSelect = this.querySelector('[data-product-select]');
    this.sameProductSwatches = this.querySelectorAll('.same-product[data-swatches] input');      
    this.media = this.querySelector('.card__media .media');
    this.secondaryImage = this.media.querySelector('[data-secondary-image]');
    this.primaryImage = this.media.querySelector('[data-primary-image]');
    this.form = this.querySelector('form');
    this.cartDrawer = document.querySelector('cart-drawer');
    this.quickviewTemplate = document.querySelector('#product-quickview');
    this.productTitle = this.dataset.productTitle;
    this.productId = this.dataset.productId;

    this.quickAddOptionClick();

    this.sameProductSwatches.forEach((swatch) => {
      swatch.addEventListener('change', this.onSwatchChange.bind(this));
    });

    if (this.variantsSelect) {
      this.variantsSelect.addEventListener('change', this.onVariantChange.bind(this));
    }

    this.swatches.forEach((swatch) => {
      swatch.addEventListener('mouseenter', this.onSwatchEnter.bind(this));
    });

    if (this.productLinkSwatches) {
      this.productLinkSwatches.addEventListener('mouseleave', this.onSwatchLeave.bind(this));
    }

    this.form && this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  connectedCallback() {
  }

  onSwatchChange(event) {
    const optionSelector = `option[data-option${
        event.target.dataset.optionPosition
      }="${event.target.value}"]`;

      this.variantsSelect.value = this.variantsSelect.querySelector(optionSelector).value;
      this.variantsSelect.dispatchEvent(new Event('change'));
  }

  onVariantChange(event) {
    const selectedOption = event.target.selectedOptions[0];

    this.querySelectorAll('[data-product-link]').forEach((link) => {
      link.setAttribute('href', `${this.dataset.url}${selectedOption.value}`)
    })

    if (!selectedOption.dataset.imageSrc || !selectedOption.dataset.imageSrcset) {
      return;
    }

    this.media.classList.remove('has-hover');
    if (this.secondaryImage) {
      this.secondaryImage.style.display = 'none';
    }
    this.primaryImage.src = selectedOption.dataset.imageSrc;
    this.primaryImage.srcset = selectedOption.dataset.imageSrcset;
  }

  onSwatchEnter(event) {
    if (this.activeSwatch) {
      this.activeSwatch.classList.remove('active');
      this.activeSwatch = event.target;
      this.activeSwatch.classList.add('active');
    }
    
    this.media.classList.remove('has-hover');
    if (this.secondaryImage) {
      this.secondaryImage.style.display = 'none';
    }
    this.primaryImage.src = event.target.dataset.productImage;
    this.primaryImage.srcset = event.target.dataset.productImage;
  }

  onSwatchLeave(event) {
    this.activeSwatch?.classList.remove('active');
    this.originalSwatch?.classList.add('active');
    this.activeSwatch = this.originalSwatch;
    this.media.classList.add('has-hover');
    if (this.secondaryImage) {
      this.secondaryImage.style.display = 'block';
    }
    this.primaryImage.src = this.originalProductImage;
    this.primaryImage.srcset = this.originalProductImage;
  }

  onSubmit(event) {
    event.preventDefault();

    const submitter = event.submitter;
    const variantId = submitter.dataset.variantId;
    this.form.querySelector('input[name="id"]').value = variantId;
    this.addItemToCart();
  }

  addItemToCart() {
    if (!this.cartDrawer) {
      this.form && this.form.submit()

      return;
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    formData.append('sections', this.cartDrawer.getSectionsToRender().map((section) => section.section));
    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((state) => {
        if (state.status) {
          console.error('Error adding to cart:', state.description);
          return;
        }

        this.cartDrawer.renderContents(state);

        // Update cart count bubble
        const cartCountBubble = document.querySelector(
          ".cart-count-bubble span"
        );
        if (cartCountBubble && state.item_count !== 0) {
          cartCountBubble.textContent = state.item_count;
        } else if (cartCountBubble && state.item_count === 0) {
          cartCountBubble.textContent = "";
        } else if (!cartCountBubble && state.item_count > 0) {
          const newCartCountBubble = document.createElement("div");
          newCartCountBubble.classList.add("cart-count-bubble");
          newCartCountBubble.innerHTML = `<span aria-hidden="true">${state.item_count}</span><span class="visually-hidden">${state.item_count} products</span>`;
          document
            .querySelector("#cart-icon-bubble")
            .appendChild(newCartCountBubble);
        }

        if (typeof publish !== 'undefined' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-card",
            productVariantId: formData.get("id"),
          });
        }
      })
      .catch((error) => {
        window.console.error(error);
      });
  }

  arrangeContent() {
    try {
      this.arrangeRow1IfEmpty('.card-row-1', '.card-row-2');
      this.arrangeRow1IfEmpty('.card-row-1-mobile', '.card-row-2-mobile');
    }
    catch (err) {
      // Ignore
    }
  }

  arrangeRow1IfEmpty(selector1, selector2) { 
    const cardRow1 = this.querySelector(selector1);
    const firstChild = cardRow1.firstElementChild;

    if (firstChild.innerHTML == null || firstChild.innerHTML == '') {
      const secondChild = cardRow1.children[1];
      if (secondChild) {
        const cardRow2 = this.querySelector(selector2);
        cardRow2.append(secondChild);
        cardRow1.remove();
      }
    }
  }

  quickAddOptionClick() {
    const quickAddOptions = this.querySelectorAll(".quickadd__button-option");
    quickAddOptions.forEach((option) => {
      if (option.classList.contains("one-size-product")) {
        const quickAddButton = this.querySelector(".quick-add-to-cart");
        const variantId = option.dataset.variantId;
        quickAddButton.setAttribute("data-variant-id", variantId);
        quickAddButton.removeAttribute("disabled");
        option.classList.add("selected");
      }
      option.addEventListener("click", function() {
        const quickAddOptions = this.parentNode.querySelectorAll(".quickadd__button-option");
        const quickAddButton = this.parentNode.parentNode.querySelector(".quick-add-to-cart");
        const variantId = this.dataset.variantId;
        quickAddOptions.forEach((option) => {
          option.classList.remove("selected");
        });
        this.classList.add("selected");
        quickAddButton.setAttribute("data-variant-id", variantId);
        quickAddButton.removeAttribute("disabled");
      });
    });
  }
}

customElements.define("product-card", ProductCard);

class AnchorNavigation extends HTMLElement {
  constructor() {
    super();

    const insertAfterSelector = this.dataset.insertAfterSelector;
    if (!insertAfterSelector) {
      return;
    }

    const insertAfterElement = document.querySelector(insertAfterSelector);
    if (!insertAfterElement) {
      return;
    }

    insertAfterElement.insertAdjacentElement('afterend', this);

    const showSelector = this.dataset.showSelector;
     if (!showSelector) {
      return;
    }

    const target = document.querySelector(showSelector);
    if (!target) {
      return;
    }

    this.createObserver(target, this.callback, this);
  }

  callback(entries, observer) {
    const anchorNavigation = document.querySelector('anchor-navigation');
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        anchorNavigation.classList.remove('visible');
      } else {
        anchorNavigation.classList.add('visible');
        anchorNavigation.style.bottom = anchorNavigation.clientHeight * -1 + 'px';
      }
    });
  }
    
  createObserver(target, callback, anchorNavigation) {
    const options = {
        root: null,
        threshold: 0.4
    };
    const observer = new IntersectionObserver(callback, options);
    observer.observe(target);
  }
}

customElements.define("anchor-navigation", AnchorNavigation);

class AtcButton extends HTMLElement {
  constructor() {
    super();
    
    this.form = this.querySelector('form');
    this.form && this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  onSubmit(event) {
    event.preventDefault();
    this.addItemToCart();
  }

  addItemToCart() {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const submitButton = this.form.querySelector('button[type="submit"]');
    const variantId = this.form.querySelector('input[name="id"]').value;
    const quantity = this.form.querySelector('input[name="quantity"]').value;

    // Add the variant ID and quantity to the cart using an AJAX request. Using form data.

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);

    config.body = formData;
    
    submitButton.setAttribute("aria-disabled", true);
    submitButton.classList.add("loading");
    submitButton.querySelector(".loading-overlay__spinner").classList.remove("hidden");

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((state) => {
        submitButton.setAttribute("aria-disabled", false);
        submitButton.classList.remove("loading");
        submitButton.querySelector(".loading-overlay__spinner").classList.add("hidden");
      })
      .catch((error) => {
        window.console.error(error);
      });
  }
}

customElements.define("atc-button", AtcButton);

class ProductSwatch extends HTMLElement {
  constructor() {
    super();

    this.swatchCircle = this.querySelector('.swatch-circle');
    const swatchName = this.swatchCircle.dataset.swatchName;
    const swatchScript = document.querySelector("script#swatch_list");
    const swatches = JSON.parse(swatchScript.innerHTML).swatches.split(',');
    const swatchObj = {};

    this.swatchList = swatches.map((swatch) => {
      const swatchArr = swatch.split(':');
      const swatchName = swatchArr[0];
      const swatchValue = swatchArr[1];

      if (!swatchObj[swatchName]) {
        swatchObj[swatchName] = swatchValue;
      }
    });

    const swatchValue = swatchObj[swatchName];

    if (!swatchValue) {
      this.remove();
      return;
    }

    // Is image
    if (swatchValue.includes('/')) {
      // Build a img node and add the swatchValue as the source. 15px x 15px
      const img = document.createElement('img');
      img.src = swatchValue;
      img.width = 15;
      img.height = 15;
      img.alt = swatchName;
      this.swatchCircle.append(img);

      return;
    }

    // Is color
    this.swatchCircle.style.backgroundColor = swatchValue;
  }
}

customElements.define("product-swatch", ProductSwatch);

// document.addEventListener('rebuy:cart.change', (event) => {
//   const cart = event.detail.cart.cart;

//   cart.items.forEach((item) => {
//     if (item.properties._embroding) {
//       let removeLineItem = false;

//       const embrodingProductId = item.properties["_embroding-product-id"];

//       if(embrodingProductId) {
//         const productExists = cart.items.find((item) => item.product_id.toString() === embrodingProductId.toString());

//         if (!productExists) {
//           removeLineItem = true;
//                 }
//       }
//       else {
//         removeLineItem = true;
//       }
      
//       if(removeLineItem) {
//         fetch('/cart/change.js', {
//           method: 'post',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({
//             id: item.key,
//             quantity: 0
//           })
//         })
//           .then((response) => response.json())
//           .then((response) => {
//             // Do nothing
//           })
//           .catch((error) => console.log(error));
//       }
//     }
//   });
// });